// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__aHX82","selects":"Documents_selects__17sM-"};